import * as React from 'react';
import { FComponent } from '../../../types/common';
import { FieldErrors } from './FieldErrors';
import {
  createChangeEvent,
  CustomTarget,
  SimulatedChangeEvent
} from '../../../hooks/useForm';
import CheckIcon from '../Icons/CheckIcon';
import LinkOutIcon from '../Icons/LinkOutIcon';

export interface LinkFieldTarget extends CustomTarget {
  name: string;
  type: 'linkfield';
  value: string;
}

type LinkFieldProps = {
  name: string;
  href: string;
  pubkey?: string;
  label?: string;
  ariaLabel?: string;
  value: string;
  onChange: (event: SimulatedChangeEvent<LinkFieldTarget>) => void;
  visited?: boolean;
  errors?: string[];
};

export const LinkField: FComponent<LinkFieldProps> = ({
  name,
  href,
  label,
  ariaLabel,
  value,
  onChange,
  visited,
  errors
}) => {
  if (!label && !ariaLabel) {
    throw new Error('LinkField must have a label or ariaLabel (or both)');
  }

  const handleClick = () => {
    const date = new Date();
    onChange(
      createChangeEvent({
        name,
        type: 'linkfield',
        value: date.toISOString()
      })
    );
  };

  const url = new URL(href);

  return (
    <div className="link-field">
      <div id="link-field" className={label ? '' : 'sr-only'}>
        {label ? label : ariaLabel}
      </div>
      <div className="link-and-message">
        {value ? <CheckIcon className="check" /> : null}
        <div>
          {value ? <div>Thank you! You can now continue filling this packet.</div> : null}
          <a
            aria-labelledby="link-field"
            href={url.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}>
            {value
              ? 'You can visit this link again at any time.'
              : 'Click here to visit this link.'}
            <LinkOutIcon className="link-out" />
          </a>
        </div>
      </div>
      <FieldErrors visited={visited} errors={errors} />
    </div>
  );
};
